import { UpdateProgramsSharingPermissionsMutation } from '@typings/operations';
import { useMutation } from '@apollo/client';
import { sharingPermissionsMutation } from '../queries';

export const useUpdateProgramsSharingPermissions = () => {
  return useMutation<UpdateProgramsSharingPermissionsMutation>(
    sharingPermissionsMutation
  );
};
